import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarPastasLogs(axios) { 
    let parametros = {
      operacao: 'buscarPastasLogs'
    };

    let retorno = {};
    
    await axios.santriGET('/rest/logServidor', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },

  async downloadArquivosLogs(api, parametros) {
    parametros.operacao = 'downloadArquivosLogs';

    let retorno = {};

    try {
      window.location.href = (api + '/rest/logServidor?' + JSON.stringify(parametros));
      retorno = Biblioteca.retornoRequisicao('N', undefined, undefined);
    } catch (error) {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);  
    }

    return retorno;
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/RLogServidor.js